__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/a454b7c/_next/";